import { getOperationAST } from 'graphql';
import { ApolloLink, ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type { OwaCachePolicyMap } from 'owa-lazy-cache-policy';
import { request } from 'owa-apollo-policy-loader';

export function cachePolicyLoaderLink(
    policies: OwaCachePolicyMap,
    getClient: () => ApolloClient<NormalizedCacheObject>
) {
    const link = new ApolloLink((operation, forward) => {
        const opNode = getOperationAST(operation?.query);

        if (!opNode || opNode.operation === 'subscription') {
            return forward(operation);
        } else {
            return request(getClient(), policies, operation, forward);
        }
    });

    return link;
}
